import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { SimpleGrid, Container, Heading } from "@chakra-ui/react"
import ReviewsItem from "./ReviewsItem"

export function Reviews() {
  const { dataJson } = useStaticQuery(graphql`
    query {
      dataJson {
        reviews {
          review
          name
        }
      }
    }
  `)

  const { reviews } = dataJson

  return (
    <section>
      <Container>
        <Heading size="3xl" textAlign="center" mb={2} fontWeight="semibold">
          Reviews
        </Heading>
        <Heading
          color="primary.200"
          fontSize="lg"
          textAlign="center"
          fontWeight="medium"
          mb={8}
        >
          See what our customers have to&nbsp;say
        </Heading>
        <SimpleGrid
          columns={{ base: 1, md: 2, xl: 3 }}
          spacing={8}
          alignItems="center"
        >
          {reviews.slice(0, 6).map((node, index) => {
            return <ReviewsItem key={index} {...node} />
          })}
        </SimpleGrid>
      </Container>
    </section>
  )
}
